import React from 'react';
import '../../components/style.css';
import Image from '../../pics';


function about() {
  return (
    <div>
         <div className="uk-section">
            <div className="uk-container">
               
                <div className="uk-child-width-1-2@m uk-grid-small uk-grid-match align-items-center" data-uk-grid>
                    
                    <div>
                        <div className="uk-card uk-card-body">
                            <img src={Image.ABOUT_SECT} alt='about images' width="100%" height="100%"/>
                        </div>
                    </div>
                    <div>
                        <div className="uk-card">
                            {/* <h2 className="text-primary uk-text-bold">
                                About Us
                            </h2> */}
                            <p className='uk-text-justify text-secondary'>
                            STRATOS AIRMAIL was founded in 2017 to revolutionize the logistics industry through innovation and a dedication to customer satisfaction. Our proprietary logistics operating system ensures the highest level of security and efficiency, providing our customers with peace of mind knowing their shipments are safe.
                            </p>
                            {/* <div className="uk-text-left">
                                
                                <button>
                                    Know More
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default about


